import type {
	AnalyticsEventType,
	AnalyticsMetadata,
	AnalyticsValue,
	EventProperties,
	IAnalyticsForwarder,
	RegisteredProperties,
} from "../types";

export abstract class BaseAnalyticsForwarder implements IAnalyticsForwarder {
	protected registeredProperties: RegisteredProperties = {};

	abstract track<T extends AnalyticsEventType>(
		event: T,
		properties: EventProperties<T>,
		metadata?: AnalyticsMetadata,
	): void;

	abstract identify(): void;

	abstract flush(): Promise<void>;

	abstract register(properties: RegisteredProperties): void;

	abstract startSessionRecording(): void;

	protected formatEventName(event: AnalyticsEventType, properties: Record<string, AnalyticsValue>): string {
		const label = (properties.label as string) || "unknown";
		const elementType = (properties.elementType as string) || "element";

		switch (event) {
			case "Click":
				return `Clicked ${elementType} with text: ${label}`;
			case "Focus":
				return `Focused on: ${label}`;
			case "Input":
				return `Typed into: ${label}`;
			case "PageView":
				return `Page View: ${properties.page as string}`;
			default:
				return event;
		}
	}

	protected mergeProperties<T extends AnalyticsEventType>(
		properties: EventProperties<T>,
		metadata?: AnalyticsMetadata,
	): Record<string, AnalyticsValue> {
		return {
			...this.registeredProperties,
			...properties,
			...metadata,
		};
	}
}
